import AuthProtected from './AuthProtected';

import Login from 'pages/Authentication/Login';
import Logout from 'pages/Authentication/Logout';
import Dashboard from 'pages/Dashboard/Dashboard';
import PeriodReportPDF from 'pages/PeriodReports/PeriodReportPDF';
import PeriodReport from 'pages/PeriodReports/PeriodReports';
import VisitReport from 'pages/VisitReports/VisitReports';
import ObjectNavPage from 'pages/Object/ObjectNavPage';
import Layout from 'components/Layouts/Layout';
import VisitReportsPDF from 'pages/VisitReports/VisitReportsPDF';
import Traps from 'pages/Traps/Traps';
import ObjectDocsDetailPage from 'pages/ObjectDocs/ObjectDocsDetail';
import Reports from 'pages/Reports/Reports';
import ObjectAnalitics from 'pages/ObjectAnalitics/ObjectAnalitics';
import Vulnerabilities from 'pages/ObjectVuls/Vulnerabilities';
import Encounters from 'pages/ObjectEnc/Encounters';
import VisitAndScheduleTasks from 'pages/VisitsAndScheduleTasks/ScheduleTasksHomePage';
import MCTDetail from 'pages/DevicesDetail/MCT/MCTDetail';
import SRBMDetail from 'pages/DevicesDetail/SRBM/SRBMDetail';
import DevicesWarehouse from 'pages/Traps/DevicesWarehouse/DevicesWareHouse';
import UsersPage from 'pages/Users/UsersPage';
import HubDetail from 'pages/Traps/HubDetail/HubDetail';
import CombinedClientsDashboard from 'pages/ClientDashboardV2/CombinedClientsDashboard';
import InteractiveMap from 'pages/InteractiveMap/InteractiveMap';
import CreatePlanPage from 'pages/InteractiveMap/createPlanPage/createPlanPage';
import SMSTDetail from 'pages/DevicesDetail/SMST/SMSTDetail';
import SRSTDetail from 'pages/DevicesDetail/SRST/SRSTDetail';
import Registration from 'pages/Authentication/Registration';
import ForgotPassword from 'pages/Authentication/ForgotPassword';
import VerificationsPage from 'pages/Authentication/VerificationsPage';
import VerificationsCode from 'pages/Authentication/VerificationsCode';
import CompletePassword from 'pages/Authentication/CompletePassword';
import DigestReport from 'pages/DigestReports/DigestReport';
import DigestReportsPDF from 'pages/DigestReports/DigestReportsPDF';
import CapacityAnalyticsPage from 'pages/CapacityAnalytics/CapacityAnalyticsPage';
import AdminDeviceIntakePage from 'pages/AdminDeviceIntake/AdminDeviceIntakePage';

const authProtectedRoutes = [
  {
    path: '/',
    exact: true,
    component: (
      <AuthProtected>
        <Layout />
      </AuthProtected>
    ),
    children: [
      { index: true, path: '/dashboard', component: <Dashboard /> },
      {
        path: '/period-report/:slug/:id/',
        exact: true,
        component: <PeriodReport />,
      },
      {
        path: '/period-report/:slug/:id/check/',
        exact: true,
        component: <PeriodReportPDF />,
      },
      {
        path: '/client-dashboard',
        exact: true,
        component: <CombinedClientsDashboard />,
      },
      {
        path: '/trap-warehouse',
        exact: true,
        component: <DevicesWarehouse />,
      },
      {
        path: '/admin/device-intake',
        exact: true,
        component: <AdminDeviceIntakePage />,
      },
      {
        path: '/users',
        exact: true,
        component: <UsersPage />,
      },
      {
        path: '/object/',
        component: <ObjectNavPage />,
        children: [
          {
            path: 'traps/',
            children: [
              {
                index: true,
                path: ':slug',
                component: <Traps />,
              },
            ],
          },
          {
            path: 'interactive-map/:slug/:planSlug?',
            component: <InteractiveMap />,
          },
          {
            path: 'create-plan/:slug',
            component: <CreatePlanPage />,
          },
          {
            index: true,
            path: 'docs/:slug',
            component: <ObjectDocsDetailPage />,
          },
          {
            index: true,
            path: 'monitorings/:slug',
            component: <Reports />,
          },
          {
            index: true,
            path: 'encounters/:slug',
            component: <Encounters />,
          },
          {
            index: true,
            path: 'vulnerabilities/:slug',
            component: <Vulnerabilities />,
          },
          {
            index: true,
            path: 'analitics/:slug',
            component: <ObjectAnalitics />,
          },
          {
            index: true,
            path: 'visits-and-scheduled-tasks/:slug',
            component: <VisitAndScheduleTasks />,
          },
        ],
      },
      {
        path: '/visit-report/:slug/:id/',
        exact: true,
        component: <VisitReport />,
      },
      {
        path: '/digest-report/:slug/:id/',
        exact: true,
        component: <DigestReport />,
      },
      {
        path: '/trap/mct/info/:slug',
        exact: true,
        component: <MCTDetail />,
      },
      {
        path: '/trap/srbm/info/:slug',
        exact: true,
        component: <SRBMDetail />,
      },
      {
        path: '/trap/srst/info/:slug',
        exact: true,
        component: <SRSTDetail />,
      },
      {
        path: '/trap/smst/info/:slug',
        exact: true,
        component: <SMSTDetail />,
      },
      {
        path: '/trap/capacity-analytics/:slug',
        exact: true,
        component: <CapacityAnalyticsPage />,
      },
      {
        path: '/visit-report/:slug/:id/check/',
        exact: true,
        component: <VisitReportsPDF />,
      },
      {
        path: '/digest-report/:slug/:id/check/',
        exact: true,
        component: <DigestReportsPDF />,
      },
      {
        path: 'hub/info/:slug/',
        exact: true,
        component: <HubDetail />,
      },
      { path: '*', component: <Dashboard /> },
    ],
  },
];

const publicRoutes = [
  {
    path: '/login',
    component: <Login />,
  },
  {
    path: '/logout',
    component: <Logout />,
  },
  {
    path: '/registration',
    component: <Registration />,
  },
  {
    path: '/forgot-password',
    component: <ForgotPassword />,
  },
  {
    path: '/verify-password-code',
    component: <VerificationsCode />,
  },
  {
    path: '/complete-password',
    component: <CompletePassword />,
  },
  {
    path: '/verify-email',
    component: <VerificationsPage />,
  },
];

export { authProtectedRoutes, publicRoutes };
